import { Tabs } from 'antd'
import { ScreenHeader } from 'components'
import {
  FlaggedCommentApprovedTab,
  FlaggedCommentDisapprovedTab,
  FlaggedCommentPendingTab,
  ReviewFlaggedCommentModal,
} from 'page-components'
import React, { useState, useMemo, useEffect } from 'react'
import { FlagStatus } from 'utility'
import { HeaderWrapper } from './dashboard'
import { GetFlaggedCommentData } from 'hooks'

export const FlaggedCommentsScreen = () => {
  const [tab, setTab] = useState(FlagStatus.FlagRequested)
  const [selected, setSelected] = useState([])
  const { data, filters, pageChanged, total, loading, refetch, updateFilters } = GetFlaggedCommentData(tab)
  const [openModal, setOpenModal] = useState({
    open: false,
    data: null,
    mode: "single",
  })

  useEffect(() => {
    setSelected([])
  }, [tab, data])

  const handleCheckboxChange = (record) => {
    setSelected((prev) =>
      prev.includes(record?._id)
        ? prev.filter((id) => id !== record?._id) // Remove if already selected
        : [...prev, record?._id], // Add if not selected
    );
  };

  const updateSelection = (data, flag) => {
    const selected = flag ? data.map(item => item._id) : [];
    setSelected(selected);
  }

  const handleFilter = (key, value) => {
    updateFilters(key, value)
  }

  const items = useMemo(
    () => [
      {
        key: FlagStatus.FlagRequested,
        label: "Comment's For Review",
        children: <FlaggedCommentPendingTab
          data={data}
          filter={filters}
          pageChanged={pageChanged}
          total={total}
          loading={loading}
          refetch={refetch}
          updateSelection={updateSelection}
          handleCheckboxChange={handleCheckboxChange}
          selected={selected}
          setSelected={setSelected}
          handleFilter={handleFilter}
        />,
      },
      {
        key: FlagStatus.Flagged,
        label: 'Removed Comments',
        children: <FlaggedCommentApprovedTab
          data={data}
          filter={filters}
          pageChanged={pageChanged}
          total={total}
          loading={loading}
          refetch={refetch}
          updateSelection={updateSelection}
          handleCheckboxChange={handleCheckboxChange}
          selected={selected}
          setSelected={setSelected}
          handleFilter={handleFilter}
        />,
      },
      {
        key: FlagStatus.Active,
        label: 'Ignored Report Comments',
        children: <FlaggedCommentDisapprovedTab
          data={data}
          filter={filters}
          pageChanged={pageChanged}
          total={total}
          loading={loading}
          refetch={refetch}
          updateSelection={updateSelection}
          handleCheckboxChange={handleCheckboxChange}
          selected={selected}
          setSelected={setSelected}
          handleFilter={handleFilter}
        />,
      },
    ],
    [selected, loading],
  )

  return (
    <div>
      <HeaderWrapper>
        <ScreenHeader text="Comments Under Review" />
      </HeaderWrapper>

      <div className="px-5">
        <div className="tabs-container">
          <Tabs
            defaultActiveKey="1"
            activeKey={tab}
            items={items}
            className="custom-tabs"
            centered
            onChange={key => setTab(key)}
          />
        </div>
      </div>
      {openModal.open && (
        <ReviewFlaggedCommentModal
          visible={openModal.open}
          data={openModal.data}
          refetch={refetch}
          selected={selected}
          mode={openModal.mode}
          tab="pending"
          onCancel={() => setOpenModal({ open: false })}
        />
      )}
    </div>
  )
}
